import { render } from "./fotito_ingles.vue?vue&type=template&id=5b396cea&scoped=true"
import script from "./fotito_ingles.vue?vue&type=script&lang=js"
export * from "./fotito_ingles.vue?vue&type=script&lang=js"

import "./fotito_ingles.vue?vue&type=style&index=0&id=5b396cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b396cea"]])

export default __exports__